<template>
  <div class="min-h-screen flex flex-col justify-center items-center pt-6 sm:pt-0 p-4">
    <logo class="mb-6 w-32 h-32"></logo>

    <h1 class="text-3xl font-bold mb-8">Выбор пользователя</h1>

    <div v-if="loading" class="flex items-center">
      <svg class="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
      </svg>
      Загрузка списка пользователей...
    </div>

    <div v-else-if="showPinCode" class="w-full max-w-md p-6 border border-gray-300 rounded-lg">
      <pin-code-input :userId="selectedUserId" :moduleRedirectId="this.$route.query.moduleRedirectId" />
      <button
        @click="showPinCode = false; selectedUserId = null;"
        class="mt-6 text-sm flex items-center gap-1"
      >
        <span class="text-lg">←</span> Назад к выбору пользователя
      </button>
    </div>

    <div v-else class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 w-full max-w-5xl">
      <div
        v-for="user in users"
        :key="user.id"
        @click="selectUser(user.id)"
        class="backdrop-blur-sm p-6 rounded-lg border border-gray-300 shadow-lg cursor-pointer"
      >
        <div class="text-center">
          <div class="w-20 h-20 bg-blue-600 text-white rounded-full mx-auto mb-4 flex items-center justify-center text-xl font-bold">
            {{ getInitials(user.first_name, user.last_name) }}
          </div>
          <h3 class="font-semibold text-xl text-gray-900">{{ user.first_name }} {{ user.last_name }}</h3>
          <p class="mt-1 text-gray-900">{{ user.role.name }}</p>
        </div>
      </div>
    </div>

    <div v-if="error" class="mt-8 text-red-300 text-center p-4 bg-red-900 bg-opacity-20 rounded-lg">
      <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 inline mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
      </svg>
      {{ error }}
    </div>
  </div>
</template>

<script>
import Logo from '@/components/Logo.vue';
import PinCodeInput from '@/components/auth/PinCodeInput.vue';
import { useAuthStore } from '@/stores/auth';

export default {
  components: {
    Logo,
    PinCodeInput
  },
  data() {
    return {
      users: [],
      loading: true,
      error: null,
      showPinCode: false,
      selectedUserId: null,
      authStore: useAuthStore()
    };
  },
  created() {
    this.getUsers();
  },
  methods: {
    getUsers() {
      this.authStore.getUsers()
        .then(users => {
          this.users = users;
          this.loading = false;
        })
        .catch(error => {
          console.error('Ошибка при получении списка пользователей:', error);
          this.error = error.message || 'Не удалось загрузить список пользователей';
          this.loading = false;
        });
    },
    getInitials(firstName, lastName) {
      return (firstName ? firstName.charAt(0) : '') + (lastName ? lastName.charAt(0) : '');
    },
    selectUser(userId) {
      this.selectedUserId = userId;
      this.showPinCode = true;
    }
  }
};
</script>

<style scoped>
.backdrop-blur-sm {
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}
</style>
